var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fields",attrs:{"title":Object.entries(_vm.$ncsCsvElementFields(_vm.document, _vm.text, _vm.elements))
                   .map(function (ref) {
                                      var k = ref[0];
                                      var v = ref[1];

                                      return (k + ": " + v);
})
                   .join('\n')}},[_c('span',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.$ncsCsvElementFields(_vm.document, _vm.text, _vm.elements)[_vm.$t('result.context.header.document.identificador')])+"\n    ("+_vm._s(_vm.shortDocumentType)+")\n  ")]),_vm._v(" "),_c('span',{staticClass:"date"},_vm._l((_vm.$documentDate(_vm.document)),function(part){return _c('span',[_vm._v(_vm._s(part)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }